<template>
  <div v-if="!item.hidden">
    <!-- 没有子菜单或只有一个子菜单 -->
    <template v-if="!hasChildrenMenu(item.children, item)">
      <el-menu-item :index="resolvePath(item.path)" :class="{'submenu-title-noDropdown': !isNest}">
        <el-icon v-if="item.meta && item.meta.icon"><component :is="item.meta.icon" /></el-icon>
        <template #title>{{ item.meta && item.meta.title }}</template>
      </el-menu-item>
    </template>

    <!-- 有子菜单 -->
    <el-sub-menu v-else :index="resolvePath(item.path)" popper-append-to-body>
      <template #title>
        <el-icon v-if="item.meta && item.meta.icon"><component :is="item.meta.icon" /></el-icon>
        <span>{{ item.meta && item.meta.title }}</span>
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-sub-menu>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { isExternal } from '@/utils/validate'
import { getMenus } from '@/api'

const props = defineProps({
  item: {
    type: Object,
    required: true
  },
  isNest: {
    type: Boolean,
    default: false
  },
  basePath: {
    type: String,
    default: ''
  }
})

// 解析路径
const resolvePath = (routePath) => {
  if (isExternal(routePath)) {
    return routePath
  }
  if (isExternal(props.basePath)) {
    return props.basePath
  }
  
  // 如果路径是绝对路径（以/开头），则直接返回
  if (routePath.startsWith('/')) {
    return routePath
  }
  
  // 处理基路径
  // 对于一级菜单(非嵌套)，直接返回routePath，无需拼接
  if (!props.isNest && !props.basePath.includes('/')) {
    return '/' + routePath
  }
  
  // 自定义路径拼接逻辑
  let path = props.basePath
  // 如果基路径已包含当前路径，则避免重复
  if (path.endsWith('/' + routePath) || path === '/' + routePath) {
    return path
  }
  
  if (!path.endsWith('/')) {
    path += '/'
  }
  if (routePath.startsWith('/')) {
    path += routePath.slice(1)
  } else {
    path += routePath
  }
  
  // 规范化路径，处理 ../ 和 ./
  const segments = path.split('/').filter(Boolean)
  const result = []
  
  for (const segment of segments) {
    if (segment === '..') {
      result.pop()
    } else if (segment !== '.') {
      result.push(segment)
    }
  }
  
  return '/' + result.join('/')
}

// 判断是否有子菜单需要显示
const hasChildrenMenu = (children = [], parent) => {
  if (!children) {
    return false
  }
  
  // 过滤掉hidden的子路由
  const showingChildren = children.filter(item => !item.hidden)
  
  // 如果有children属性并且有可显示的子路由，则显示子菜单
  if (showingChildren.length > 0) {
    return true
  }
  
  // 没有子菜单则返回false
  return false
}
</script>

<style lang="scss" scoped>
.el-menu-item, .el-sub-menu {
  .el-icon {
    margin-right: 10px;
  }
}
</style> 